/* Favoriler — Swym yerine bizim müşteri hesabı (account.hepsikanadadan.com, hepsi-ops /api/customer/favorites).
   - Portala giriş yapmışsa (aynı site çerezi): ♡ doğrudan hesaba yazılır, tüm cihazlarda görünür.
   - Misafir: ♡ bu cihaza kaydedilir (localStorage); portala giriş yapınca hesaba aktarılır
     (sitede bir sonraki açılışta otomatik, ya da header ♡ linkiyle portala giderken ?fav_ekle= ile).
   Butonlar: snippets/hk-favorite-button.liquid (data-hk-fav="ürün id"); header linki: a[data-hk-fav-link]. */
(function () {
  'use strict';
  var cfg = window.hkFavorites || {};
  var PORTAL = (cfg.portal || 'https://account.hepsikanadadan.com').replace(/\/+$/, '');
  var API = PORTAL + '/api/customer/favorites';
  var LS_KEY = 'hk_fav_local';
  var state = { loggedIn: false, ids: {} };

  function readLocal() {
    try { var a = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); return Array.isArray(a) ? a.map(String) : []; } catch (e) { return []; }
  }
  function writeLocal(ids) {
    try { ids.length ? localStorage.setItem(LS_KEY, JSON.stringify(ids)) : localStorage.removeItem(LS_KEY); } catch (e) {}
  }
  function setIds(list) { state.ids = {}; list.forEach(function (id) { state.ids[String(id)] = true; }); }
  function idList() { return Object.keys(state.ids); }

  function api(method, url, body) {
    return fetch(url, {
      method: method,
      credentials: 'include',
      headers: body ? { 'Content-Type': 'application/json' } : {},
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (r.status === 401) state.loggedIn = false;
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function paint() {
    var buttons = document.querySelectorAll('[data-hk-fav]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = !!state.ids[b.getAttribute('data-hk-fav')];
      if (b.classList.contains('is-on') === on && b.getAttribute('aria-pressed') === String(on)) continue;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
      b.title = b.getAttribute('aria-label');
    }
    var n = idList().length;
    var counts = document.querySelectorAll('.hk-fav-count');
    for (var j = 0; j < counts.length; j++) { counts[j].textContent = n ? String(n) : ''; counts[j].hidden = !n; }
  }

  // Portal "Favorilerim" linki; misafirin cihazdaki favorileri ?fav_ekle= ile girişten sonra hesaba eklenir
  function favoritesUrl() {
    var u = PORTAL + '/?view=favoriler';
    var local = state.loggedIn ? [] : readLocal();
    return local.length ? u + '&fav_ekle=' + encodeURIComponent(local.join(',')) : u;
  }

  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hk-fav-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 6000);
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-hk-fav');
    var add = !state.ids[id];
    if (add) state.ids[id] = true; else delete state.ids[id];
    btn.classList.remove('is-pop'); void btn.offsetWidth; if (add) btn.classList.add('is-pop');
    paint();

    if (state.loggedIn) {
      var req = add ? api('POST', API, { productIds: [id] }) : api('DELETE', API + '?productId=' + encodeURIComponent(id));
      req.then(function (d) { setIds(d.ids || []); paint(); })
        .catch(function () {
          if (add) delete state.ids[id]; else state.ids[id] = true;
          paint();
          if (!state.loggedIn) toast('Oturumunuz sona ermiş. <a href="' + favoritesUrl() + '">Tekrar giriş yapın</a>');
        });
      return;
    }
    writeLocal(idList());
    if (add) toast('♡ Favorilere eklendi. Tüm cihazlarınızda görmek için <a href="' + favoritesUrl() + '">giriş yapın</a>.');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-hk-fav]') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(btn);
      return;
    }
    var link = t && t.closest ? t.closest('a[data-hk-fav-link]') : null;
    if (link) link.href = favoritesUrl();
  }, true);

  function start() {
    var local = readLocal();
    setIds(local);
    paint();
    api('GET', API + '?ids=1')
      .then(function (d) {
        state.loggedIn = true;
        var server = (d.ids || []).map(String);
        var pending = local.filter(function (id) { return server.indexOf(id) === -1; });
        setIds(server);
        if (!pending.length) { writeLocal([]); return; }
        return api('POST', API, { productIds: pending }).then(function (d2) { setIds(d2.ids || []); writeLocal([]); });
      })
      .catch(function () { /* misafir ya da portal erişilemiyor: cihazdaki liste geçerli */ })
      .then(paint);

    // Filtre / sonsuz kaydırma / hızlı bakış ile sonradan gelen kartlar da boyansın
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paint(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
